import { Link } from "react-router-dom";
import { ChevronRight } from "lucide-react";
import { useCopy } from "../i18n/copy";

export const Breadcrumbs = ({ items }) => {
  const c = useCopy("crumbs");
  return (
    <nav aria-label={c.aria} className="container-site pt-6" data-testid="breadcrumbs">
      <ol className="flex flex-wrap items-center gap-1.5 text-xs text-slate-600">
        {items.map((item, i) => (
          <li key={item.path} className="flex items-center gap-1.5">
            {i > 0 && <ChevronRight size={12} aria-hidden="true" className="text-slate-400" />}
            {i === items.length - 1 ? (
              <span aria-current="page" className="text-ink font-medium">{item.name}</span>
            ) : (
              <Link to={item.path} className="hover:text-terracotta transition-colors">{item.name}</Link>
            )}
          </li>
        ))}
      </ol>
    </nav>
  );
};
